<template>
  <div class="empty" v-if="show">
    <img :src="icon" alt="">
    <p>{{text}}</p>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    show: Boolean,
    icon: {
      type: String,
      default: require('@/assets/icons/empty.png')
    },
    text: {
      type: String,
      default: '暂无信息'
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .empty{
    padding: 20% 0;
    width: 100%;
    img{
      width: 100px;
      display: block;
      margin: 0 auto;
    }
    p{
      text-align: center;
      color: #666;
      font-size: 14px;
      padding-top: 10px;
    }
  }
</style>
